var map = {
	"./AfricaMap.png": 7255,
	"./algeria.png": 6247,
	"./angola.png": 2617,
	"./benin.png": 9125,
	"./botswana.png": 5456,
	"./burkina-faso.png": 5387,
	"./burundi.png": 9906,
	"./cameroon.png": 5483,
	"./central-african-republic.png": 5186,
	"./chad.png": 1758,
	"./cote-d-ivoire.png": 992,
	"./democratic-republic-of-the-congo.png": 4704,
	"./djibouti.png": 8020,
	"./egypt.png": 4136,
	"./equatorial-guinea.png": 4594,
	"./eritrea.png": 8434,
	"./eswatini.png": 3116,
	"./ethiopia.png": 6193,
	"./gabon.png": 2755,
	"./gambia.png": 7366,
	"./ghana.png": 21,
	"./guinea-bissau.png": 7551,
	"./guinea.png": 9015,
	"./kenya.png": 7776,
	"./lesotho.png": 9567,
	"./liberia.png": 2479,
	"./libya.png": 7083,
	"./madagascar.png": 917,
	"./malawi.png": 9269,
	"./mali.png": 1259,
	"./mauritania.png": 7353,
	"./morocco.png": 2824,
	"./mozambique.png": 5030,
	"./namibia.png": 7467,
	"./niger.png": 3267,
	"./nigeria.png": 5673,
	"./republic-of-the-congo.png": 7997,
	"./rwanda.png": 7224,
	"./senegal.png": 4531,
	"./sierra-leone.png": 9822,
	"./somalia.png": 5637,
	"./south-africa.png": 3129,
	"./south-sudan.png": 5636,
	"./sudan.png": 2747,
	"./tanzania.png": 3314,
	"./togo.png": 4096,
	"./tunisia.png": 7687,
	"./uganda.png": 9421,
	"./western-sahara.png": 5422,
	"./zambia.png": 6587,
	"./zimbabwe.png": 5311
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2371;